export { resolveEnvironment } from './environments';
export type {
  EnvironmentConfig,
  EnvironmentType,
  IdentityEnvironment,
} from './environments';
